import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./MetricsSection.module.scss";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { useState } from "react";
import { metrics, TMetric } from "./consts";
import { Input } from "@/frontend/shared/ui/Input";
import { MagnifyingGlassIcon, PlusIcon, TrashIcon } from "@/frontend/shared/assets/icons";



export function MetricsSection() {
  const [selectedMetrics, setSelectedMetrics] = useState<TMetric[]>([]);
  const [availableMetrics, setAvailableMetrics] = useState<TMetric[]>(metrics);

  function MetricSelect({ metric }: { metric: TMetric }) {

    function handleSelect() {
      setSelectedMetrics((prev) => [...prev, metric]);
      setAvailableMetrics((prev) => prev.filter((m) => m.name !== metric.name));
    }

    return <div className={styles.metricContainer}>
      <div className={styles.metricTop}>
        <Typography variant="label-4" color="greyscale800">
          {metric.name}
        </Typography>
        <div onClick={handleSelect}>
          <PlusIcon />
        </div>

      </div>
      <div>
        <Typography variant="body-3" color="greyscale800">
          {metric.values.join(", ")}
        </Typography>
      </div>
    </div>
  }

  function MetricForm({ metric }: { metric: TMetric }) {
    const [values, setValues] = useState<string[]>([...metric.values.map(() => "")]);

    function handleDelete() {
      setSelectedMetrics((prev) => prev.filter((m) => m.name !== metric.name));
      setAvailableMetrics((prev) => [...prev, metric]);
    }

    return <div className={styles.metricForm}>
      <div className={styles.formTitle}>
        <Typography variant="heading-7" color="greyscale600">
          {metric.name}
        </Typography>
        <NormalButton className={styles.delButton} size="small" variant="tertiary" color="greyscale600" leftIcon={<TrashIcon className={styles.trashIcon} />} onClick={handleDelete}>Delete</NormalButton>
      </div>

      {metric.values.map((value, n) => (
        <div className={styles.inputContainer}>
          <Typography variant="label-4" color="greyscale800">
            {value}
          </Typography>
          <Input placeholder={value} inputSize={"small"} value={values[n]} onChange={(e) => setValues((prev) => prev.map((v, i) => i === n ? e.target.value : v))} />
        </div>
      ))}
    </div>

  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.topMetricsContainer}>
          <Typography variant="heading-6" color="greyscale900">
            Metrics
          </Typography>
        </div>
        <div className={styles.selectedMetrics}>
          {selectedMetrics.map((metric) => (
            <MetricForm metric={metric} />
          ))}
        </div>
        <div className={styles.bottomButtonsContainer}>
          <NormalButton size="large">Proceed</NormalButton>
          <NormalButton size="large" variant="secondary" color="greyscale800">
            Step back
          </NormalButton>
        </div>
      </div>
      <div className={styles.metricsContainer}>
        <div className={styles.metricsContTitle}>
          <Typography variant="heading-7" color="greyscale600">
            Import Metrics
          </Typography>
          <MagnifyingGlassIcon />
        </div>
        <div className={styles.metricsCont}>
          {availableMetrics.map((metric) => (
            <MetricSelect metric={metric} />
          ))}
        </div>
      </div>
    </div>
  );
}
